<template>
    <item :title="title" :subTitle="subtitle" iconClass="ogc-icon-hetong" :isActive="isActive">
        <template slot="buttons">
            <el-button class="button" round plain @click="onShow" v-if="state == 0">上传证书</el-button>
            <el-button class="button" type="primary" round plain @click="onShow" v-else-if="state == 1">审批中</el-button>
            <el-button class="button" type="success" round plain @click="onShow" v-else-if="state == 2">查看证书</el-button>
            <el-button class="button" type="danger" round plain @click="onShow" v-else-if="state == 9">重新上传</el-button>
        </template>

        <fc-dialog :title="state == 0 || state == 9 ? '上传资质证书' : '查看资质证书' " :visible.sync="visible">

            <div class="img-box">
                <el-image v-if="info.State > 0 && info.State < 9" class="img" :src="info.ImageUrl" :preview-src-list="[info.ImageUrl]"></el-image>
                <el-image v-else-if="hasTestImg" class="img" :src="testImg" :preview-src-list="[testImg]"></el-image>
                <el-upload v-show="(info.State <= 0 || info.State == 9) && !hasTestImg" ref="uploader" class="img-uploader" :action="uploadUrl" :show-file-list="false" :headers="uploadHeaders"
                    :on-change="beforeAvatarUpload" :on-success="onAvatarSuccess" :auto-upload="false">
                    <img v-if="info.State == 9 || info.State == -1" :src="info.ImageUrl"  class="avatar">
                    <div class="mode">
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                        <p>{{ info.State == 0 ? '点击上传证书' : info.State == 9 ? '审批被驳回，点击重新上传' : '证书已过期，点击重新上传'}}</p>
                    </div>
                </el-upload>
                <div class="tips">

                    <p><span>资质：</span>{{ qualification }}</p>
                    <p><span>证书：</span>{{ certificate }}</p>

                    <template v-if="!hasTestImg">
                        <div class="tip-state">
                            <span>资质状态： </span>
                            <el-tag v-if="info.State == 0">未上传</el-tag>
                            <el-tag type="danger" v-else-if="info.State == -1">已过期</el-tag>
                            <el-tag type="warning" v-else-if="info.State == 1">审批中</el-tag>
                            <el-tag type="success" v-else-if="info.State == 2">审批通过</el-tag>
                            <el-tag type="danger" v-else-if="info.State == 9">驳回</el-tag>
                            <span style="margin-left: 20px;">资质有效期： </span>
                            <span v-if="info.State > 0">至 {{ info.ExpirationTime || ExpirationTime }}</span>
                        </div>

                        <el-alert title="您未上传该资质证书，点击右侧 + 号可上传" type="info" v-if="info.State == 0"></el-alert>
                        <el-alert title="您已上传该证书，正在审批中，请耐心等待..." type="warning" v-else-if="info.State == 1"></el-alert>
                        <el-alert title="恭喜，您上传的证书已通过审批，您已获得该资质！" type="success" v-else-if="info.State == 2"></el-alert>
                        <template v-else-if="info.State == 9">
                            <el-alert title="很抱歉，您上传的证书未通过我们的审批，您可点击右侧 + 号重新上传" type="error"></el-alert>
                            <el-alert :title="'驳回原因：' + info.Message" type="error"></el-alert>
                        </template>
                        <img src="/static/images/me/q_flow.png" alt="" class="q-flow">
                    </template>
                    <template v-else>
                        <div class="tip-state">
                            <span>提示： </span>
                            <el-tag type="warning">您已选择要上传的证书，填写证书有效期，点击保存即可完成上传！</el-tag>
                        </div>
                        <div style="margin-top: 100px;">
                            <el-form>
                                <el-form-item label="证书有效期">
                                    <el-date-picker v-model="ExpirationTime" type="date" placeholder="选择证书有效期" format='yyyy-MM-dd' :clearable="false"></el-date-picker>
                                </el-form-item>
                            </el-form>
                        </div>
                    </template>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button type="success" :disabled="uploading" v-if="hasTestImg" @click="submit"> 提 交 </el-button>
                <el-button type="success" @click="cancel"> 关 闭 </el-button>
            </div>
        </fc-dialog>

    </item>
</template>

<script type="text/javascript">

import AutoForm from '@/components/AutoForm'
import FcDialog from '@/components/Dialogs/Dialog'
import Item from './OptionItem'

export default {
    components: {
        Item, FcDialog, AutoForm
    },
    props: {
        id: {
            type: String,
            required: true
        },
        qualification: {
            type: String,
            default: null
        },
        certificate: {
            type: String,
            default: null
        },
        state: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            info: {
                ImageUrl: '',
                Message: '',
                State: 0,
              ExpirationTime:''
            },
            testImg: '',
            ExpirationTime:'',
            types: ['png', 'jpg', 'jpeg', 'bmp'],
            maxSize: 2,
            visible: false,
            uploading: false,
            form: { Password:'', RePassword:'', vcode:'' },
            formTemplate: [
                { col: 24, tips: '安全认证', type: 'tips' },
                { col: 24, label: '短信验证码', prop: 'vcode' },
                { col: 24, label: '新密码', prop: 'Password', type: 'password' },
                { col: 24, label: '确认密码', prop: 'RePassword', type: 'password' },
            ],
            rules: {

            },
            url: {
                uploader: SZH.assets.api + "/Custom/PostQualityImage",
                get: SZH.assets.api + "/Authen/GetQualificationsInfo",
            },
        }
    },
    methods: {
        onShow() {
            this.visible = true;
        },
        cancel() {
            this.testImg = '';
            this.ExpirationTime = '';
            this.visible = false;
        },
        submit() {
            let currentTime = new Date().format('yyyy-MM-dd');
            if(this.hasTestImg && this.ExpirationTime) {
              let strTime = this.ExpirationTime.format('yyyy-MM-dd').toString();        // toString
              if(strTime<currentTime){
                this.$message.error('证书有效期不能选择今天之前的过去时间')
              }else{
                this.uploading = true;
                this.$refs['uploader'].submit();
              }
            }
            else {
                this.$message.error('请选择证书文件并填写证书有效期之后再进行上传！');
            }
        },
        beforeAvatarUpload(fileImte) {
            var self = this;
            var file = fileImte.raw;
            let typeIsOk = self.types.length == 0;
            for (let i = 0; i < self.types.length; i++) {
                switch (self.types[i]) {
                    case "jpeg":
                        typeIsOk = typeIsOk || file.type == 'image/jpeg';
                        break;
                    case "png":
                        typeIsOk = typeIsOk || file.type == 'image/png';
                        break;
                    default:
                        break;
                }
            }
            const sizeIsOk = file.size / 1024 / 1024 < self.maxSize;
            if (!typeIsOk) {
                var types = "[ ";
                self.types.forEach(type => {
                    types += types == "[ " ? type : ', ' + type;
                });
                types += " ]";
                self.$message.error('文件格式不支持!\n仅支持 ' + types + ' 等文件格式。');
            } else if (!sizeIsOk) {
                self.$message.error('文件大小不能超过 ' + self.maxSize + 'MB!');
            }

            if(typeIsOk && sizeIsOk) {
                var reader = new FileReader();
                reader.readAsDataURL(file);

                //确保文件成功获取，base64数据量比较大
                reader.onload = function (event) {
                    var e = event || window.event
                    self.testImg = e.target.result;
                }
            }
            else {
                this.$refs['uploader'].clearFiles();
                self.testImg = '';
            }
            return false;
        },
        onAvatarSuccess(res, file) {
            this.$emit("uploaded", res, file);
            if( res.State == 1) {
                this.info.ImageUrl = SZH.assets.image + res.Data.Url;
                this.info.State = 1;

                this.$message({
                    message: '恭喜，上传成功！我们将在三个工作日内完成审批工作...',
                    type: 'success'
                });

                this.cancel();
                setTimeout(() => {
                    this.testImg = '';
                    this.ExpirationTime = new Date().format('yyyy-MM-dd')
                }, 300);
            }
            else {
              this.$message.error('上传失败');
            }
            this.uploading = false;
        },
        loadData() {
            var self = this;
            self.$http.post(self.url.get, {
                Data: self.id
            }).then(result => {
                if (result.State == 1 && result.Data) {
                    self.info.ImageUrl = SZH.assets.image + result.Data.Url;
                    self.info.State = result.Data.State;
                    self.info.Message = result.Data.Message;
                    self.info.ExpirationTime = result.Data.ExpirationTime;
                } else { }
            }, () => {  });
        }
    },
    computed: {
        title() {
            var str = '';
            switch(this.state) {
                case 0 :
                    str = ''
                    break;
                case 9 :
                    str = '（驳回）'
                    break;
                case 1 :
                    str = '（审批中）'
                    break;
                case 2 :
                    str = '（已审批）'
                    break;
            }
            return str + this.qualification;
        },
        subtitle() {
            return '上传 ' + this.certificate + ' 后，可购买相关产品。';
        },
        hasTestImg() {
            return !(this.testImg == null || this.testImg == '');
        },
        isActive() {
            return this.state == 2;
        },
        uploadHeaders(){
            var token = localStorage.ms_token;
            return { Authorization: 'Bearer ' + token };
        },
        uploadUrl() {
            if(this.ExpirationTime) {
                var time = new Date(this.ExpirationTime);
                return this.url.uploader + '?id=' + this.id + '&ExpirationTime=' + (time.format('yyyy-MM-dd'));
            }
            else {
                return this.url.uploader + '?id=' + this.id + '&ExpirationTime=';
            }
        }
    },
    created() {
    },
    mounted() {
        this.info.State = this.state;
    },
    watch: {
        visible(val) {
            if(val) {
              this.uploading = false;
                for(var i in this.info) {
                    this.info[i] = '';
                }
                this.loadData();
            }
        }
    }
}
</script>

<style type="text/css" scoped>

.button {
    padding: 5px 10px;
}

.types {
    overflow: hidden;
    margin-top: 30px;
}

.type-item {
    width: calc(50% - 20px);
    border: 1px solid #CCC;
    padding: 30px 10px;
    text-align: center;
    float: left;
    cursor: pointer;
}
.type-item + .type-item {
    float: right;
}
.type-item:only-child {
    float: none;
    margin:0 auto;
}


.type-item.active {
    border: 3px solid #0A529C;
}

.type-item > .icon {
    height: 150px;
    line-height: 150px;
}
.type-item:last-child > .icon {
    padding-top: 20px;
}

.type-item > h3 {
    font-weight: 700;
    line-height: 30px;
}


/* 证书 */

.img-box {
    overflow: hidden;
}

.img-box > .img {
    width: 260px;
    height: 400px;
    float: right;
}

.img-box > .img-uploader {
    width: 260px;
    height: 400px;
    float: right;
    border: 1px solid #8c939d;
    position: relative;
}

.img-box > .img-uploader .el-upload:hover {
    border-color: #409EFF;
}

.img-box > .img-uploader .mode{
    width: 260px;
    height: 400px;
    background: rgba(150,150,150,0.85);
    position: absolute;
    top: 0;
    left: 0;
    color: #eee;
}

.img-box > .img-uploader .mode > .avatar-uploader-icon {
    font-size: 60px;
    font-weight: 700;
    color: #eee;
    width: 260px;
    text-align: center;
    margin-top: 150px;
    margin-bottom: 20px;
}


.img-box > .img-uploader .avatar {
    width: 260px;
    height: 400px;
}

.img-box > div.tips {
    width: calc(100% - 280px);
    height: 400px;
    float: left;
}

.img-box > div.tips > .tip-state{
    height: 50px;
    line-height: 50px;
}

.img-box > div.tips > p{
    height: 35px;
    line-height: 35px;
}

.img-box > div.tips > .tip-state > span,
.img-box > div.tips > p > span{
    font-weight: 700;
}

.img-box > div.tips > .q-flow{
    max-width: 100%;
    max-height: 220px;
    margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/views/Me/Info/components/Qualification.vue